import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import MessageIcon from "@mui/icons-material/Message";
import "./style.css";
import { useNavigate } from "react-router-dom";
import Reportselectezibox from "@/components/Report to selectezi";

const Searchicon = () => {
  const navigate = useNavigate();

  const [selectezireport, setSelectezireport] = useState(false);

  return (
    <div>
      <Row className="customer-support-title-row align-items-center">
        <Col xs={12} md={8}>
          <h3 className="customer-support-title mt-4">Customer Support</h3>
        </Col>
        <Col xs={12} md={4} className="customer-support-report-action">
          <button
            className="btns-sty mt-4 p-1"
            onClick={() => setSelectezireport(true)}
          >
            {" "}
            <MessageIcon fontSize="small" /> Report To selectezi
          </button>
        </Col>
      </Row>
      <Reportselectezibox
        selectezireport={selectezireport}
        setSelectezireport={setSelectezireport}
      />
    </div>
  );
};

export default Searchicon;
